import http from '../../../../http/base';
import { API_PATHS } from '../../../../http/configs';

export function enrollIntoAFFacilityWithinProgram(membersAFFacilityWithinProgramEnrollment)
{
    return http.post(API_PATHS.enrollIntoAFFacilityWithinProgram, membersAFFacilityWithinProgramEnrollment);
}